export default __webpack_public_path__ + "static/media/icons8-linkedin-circled.f757ed99.gif";